import { api } from 'lib/httpClient';

export const getCompanyLastUpdate = (companyId, reportingId, firmId) => {
  return () => {
    return api
      .get(`investor-reporting/company-last-update`, {
        params: { companyId, reportingId, firmId },
      })
      .then((response) => {
        if (response.status === 200) {
          return Promise.resolve(response);
        }
      })
      .catch((error) => {
        return Promise.resolve({ error: error.response.data.responseMsg });
      });
  };
};
